import { actions } from './cost_transaction/actions'
import { getters } from './cost_transaction/getters'
import { state } from './cost_transaction/state'
import { mutations } from './cost_transaction/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
